import { createAppStore } from "services/redux/configure-store";
import { setCache } from "services/redux/state-cache";
import HelperDevelopment from "utils/helper-development";

const store = createAppStore();

if( HelperDevelopment.isDev() ) {
	store.subscribe(() => {
		return setCache(store.getState());
	} );
}

export default store;
